import React from 'react';

const ChevronIcon = ({ direction = 'left', className = '' }) => (
  <svg
    className={className}
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    style={{ transform: direction === 'right' ? 'rotate(180deg)' : undefined }}
  >
    <path
      d="M7.5 2.5L3 8l4.5 5.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronIcon;
